import { useState, useEffect } from 'react';
import axios from 'axios';
import {
  GROCERY_MAIN_CATEGORIES_URL,
  GROCERY_CATEGORY_GROUPS_URL,
  GROCERY_MAIN_CATEGORIES_ITEMS_URL,
} from '../helpers/Constant';

const useGroceryData = () => {
  const [mainCategories, setMainCategories] = useState([]);
  const [categoryGroups, setCategoryGroups] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [categoriesPagination, setCategoriesPagination] = useState(null);
  const [categoriesLoading, setCategoriesLoading] = useState(false);
  const [groupsPagination, setGroupsPagination] = useState(null);

  // Fetch main categories with items (POST)
  const fetchMainCategories = async (page = 1, perPage = 6) => {
    setCategoriesLoading(true);
    try {
      const response = await axios.post(GROCERY_MAIN_CATEGORIES_URL, {
        page,
        per_page: perPage,
      });
      const { data } = response.data;
      setMainCategories(data.data);
      setCategoriesPagination({
        current_page: data.current_page,
        last_page: data.last_page,
        per_page: data.per_page,
        total: data.total,
        next_page_url: data.next_page_url,
        prev_page_url: data.prev_page_url,
        from: data.from,
        to: data.to,
      });
    } catch (err) {
      setError(err);
    } finally {
      setCategoriesLoading(false);
    }
  };

  // Fetch category groups (POST)
  const fetchCategoryGroups = async (page = 1, perPage = 10) => {
    try {
      const response = await axios.post(GROCERY_CATEGORY_GROUPS_URL, {
        page,
        per_page: perPage,
      });
      const { data } = response.data;
      setCategoryGroups(data.data);
      setGroupsPagination({
        current_page: data.current_page,
        last_page: data.last_page,
        per_page: data.per_page,
        total: data.total,
        next_page_url: data.next_page_url,
        prev_page_url: data.prev_page_url,
        from: data.from,
        to: data.to,
      });
    } catch (err) {
      setError(err);
    }
  };

  // Fetch all categories with items (POST) - if needed
  const fetchAllCategoriesWithItems = async (page = 1, perPage = 10) => {
    try {
      const response = await axios.post(GROCERY_MAIN_CATEGORIES_ITEMS_URL, {
        page,
        per_page: perPage,
      });
      const { data } = response.data;
      setMainCategories(data.data);
    } catch (err) {
      setError(err);
    }
  };

  // Initial load
  useEffect(() => {
    const loadData = async () => {
      setLoading(true);
      await Promise.all([
        fetchMainCategories(1, 6),
        fetchCategoryGroups(1, 10),
      ]);
      setLoading(false);
    };
    loadData();
  }, []);

  return {
    mainCategories,
    categoryGroups,
    loading,
    error,
    categoriesPagination,
    categoriesLoading,
    groupsPagination,
    fetchMainCategories,
    fetchCategoryGroups,
    fetchAllCategoriesWithItems,
  };
};

export default useGroceryData;